import Root from './containers/Root.tsx'
import './assets/styles/main.scss'

export default Root
